// src/services/maquinaMapaService.js

import api from "../api/api"; // Caminho correto para api.js
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const maquinaMapaService = {
  // Método para buscar todos os setores
  async fetchSetores() {
    try {
      const url = `${BASE_URL}/maquinas-setores`;
      const response = await api.get(url);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Dados dos setores não estão completos.");
      }
    } catch (error) {
      handleError(error, "Erro ao obter setores.");
    }
  },

  // Método para buscar todos os sub-setores
  async fetchSubSetores() {
    try {
      const url = `${BASE_URL}/maquinas-sub-setores`;
      const response = await api.get(url);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Dados dos sub-setores não estão completos.");
      }
    } catch (error) {
      handleError(error, "Erro ao obter sub-setores.");
    }
  },

  // Método para buscar todas as máquinas
  async fetchMaquinas() {
    try {
      const url = `${BASE_URL}/maquinas-lista-completa`;
      const response = await api.get(url);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Dados das máquinas não estão completos.");
      }
    } catch (error) {
      handleError(error, "Erro ao obter máquinas.");
    }
  },

  // Método para reposicionar as máquinas (enviar dados das filas para a API)
  async reposicionarMaquinas(params) {
    try {
      console.log('nicole',params);

      const url = `${BASE_URL}/maquinas-mapa-reposicionar`;
      const response = await api.post(url, params, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao reposicionar máquinas.");
      }
    } catch (error) {
      handleError(error, "Erro ao reposicionar máquinas.");
    }
  },

  // Método para adicionar uma máquina a uma fila específica
  async adicionarMaquinaFila(idFila, maquina) {
    try {
      const url = `${BASE_URL}/filas/${idFila}/adicionar-maquina`;
      const response = await api.post(url, maquina, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao adicionar máquina à fila.");
      }
    } catch (error) {
      handleError(error, "Erro ao adicionar máquina à fila.");
    }
  },

  // Método para remover uma máquina de uma fila específica
  async removerMaquinaFila(idFila, idMaquina) {
    try {
      const url = `${BASE_URL}/filas/${idFila}/remover-maquina/${idMaquina}`;
      const response = await api.delete(url);

      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        throw new Error("Erro ao remover máquina da fila.");
      }
    } catch (error) {
      handleError(error, "Erro ao remover máquina da fila.");
    }
  },



};

// Função auxiliar para tratar erros
function handleError(error, mensagemPadrao) {
  if (error.response) {
    if (error.response.status === 404) {
      throw new Error("Recurso não encontrado.");
    } else {
      throw new Error(error.response.data.message || mensagemPadrao);
    }
  } else if (error.request) {
    throw new Error("Erro de rede. Por favor, verifique sua conexão.");
  } else {
    throw new Error(error.message || mensagemPadrao);
  }
}
